/** ODP v2 color tokens — dark theme palette */

export const colors = {
  background: {
    page: '#0D0D0D',
    default: '#1A1A1A',
    paper: '#252525',
    sidebar: '#1A1A1A',
    elevated: '#2A2A2E',
  },
  primary: {
    main: '#0078D6',
    hover: '#006CBD',
    gradient: { from: '#0078D6', to: '#16E1CB' },
  },
  text: {
    primary: '#FFFFFF',
    secondary: 'rgba(255,255,255,0.55)',
    link: '#4A9EFF',
  },
  border: {
    default: '#333333',
    secondary: '#FFFFFF80',
    subtle: '#FFFFFF14',
  },
  danger: {
    default: '#FF6B6B',
    hover: '#FF4444',
  },
  star: '#FACC00',
  decorative: {
    netStroke: '#B0B0B0',
  },
  status: {
    healthy: '#198025',
    degraded: '#FACC00',
    critical: '#D92121',
    unknown: '#333333',
  },
  chart: {
    green: '#198025',
    black: '#333333',
    red: '#D92121',
    yellow: '#FACC00',
  },
  sidebar: {
    active: 'rgba(255,255,255,0.11)',
    hover: 'rgba(255,255,255,0.07)',
    activeText: '#FFFFFF',
    inactiveText: 'rgba(255,255,255,0.55)',
    hoverText: 'rgba(255,255,255,0.9)',
    activeIndicator: '#0078D6',
    aside: '#171717',
  },
  tags: {
    background: '#3F3F3F',
    emphasisBackground: '#555555',
    disabled: '#555555',
  },
  cards: {
    background: '#1A1A1A',
    disabled: '#353535',
  },
  icon: {
    disabled: '#9A9A9A',
  },
} as const;
